import React, { Component } from 'react'
import { connect } from 'react-redux'

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton'

import commentActions from 'actions/commentActions'

export class AddButton extends Component{
	render(){
		let { props } = this
		return(
			<RaisedButton
				label="REPLY"
				icon={<i className="material-icons" style={{color: "#FFF"}}>comment</i>}
				backgroundColor="#009688"
				style={{margin: "0px", float:"right"}}
				labelColor="#FFF"
				onClick={()=>{props.COMMENT_ADD(props.objectID)}}
			/>
		)
	}
}
export default connect(null, commentActions)(AddButton)



// WEBPACK FOOTER //
// ./src/components/Communication/ReplyButton.js